import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
interface GuaranteeProps {
  variant?: 'full' | 'compact';
}
export const Guarantee: React.FC<GuaranteeProps> = ({
  variant = 'full'
}) => {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7
  }} className="w-full max-w-3xl mx-auto px-6 py-12 md:py-16" data-id="element-91">
      <div className="relative bg-gradient-to-b from-cosmic-800/60 to-cosmic-900/60 border border-amber-500/30 rounded-2xl px-6 py-10 md:px-12 md:py-12 overflow-hidden shadow-[0_0_40px_rgba(245,197,66,0.08)]" data-id="element-92">
        {/* Ambient glows */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-amber-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-93" />
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-amber-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-94" />

        <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-10 text-center md:text-left" data-id="element-95">
          {/* Seal */}
          <div className="flex-shrink-0 relative" data-id="element-96">
            <motion.div animate={{
            rotate: [0, 360]
          }} transition={{
            duration: 60,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 rounded-full border-2 border-dashed border-amber-400/40" data-id="element-97" />
            <div className="relative w-32 h-32 md:w-36 md:h-36 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex flex-col items-center justify-center shadow-[0_0_30px_rgba(245,197,66,0.4)] m-2" data-id="element-98">
              <ShieldCheckIcon className="w-7 h-7 text-cosmic-900 mb-1" data-id="element-99" />
              <span className="font-serif font-bold text-3xl md:text-4xl text-cosmic-900 leading-none" data-id="element-100">
                30
              </span>
              <span className="font-serif text-[10px] md:text-xs text-cosmic-900/80 uppercase tracking-widest mt-1" data-id="element-101">
                Días
              </span>
            </div>
          </div>

          {/* Copy */}
          <div className="flex-1" data-id="element-102">
            <h3 className="text-2xl md:text-3xl font-serif text-amber-400 mb-4 leading-tight" data-id="element-103">
              Garantía de 30 días.
              <br data-id="element-104" />
              <span className="italic text-amber-200" data-id="element-105">Sin preguntas.</span>
            </h3>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-3" data-id="element-106">
              Si en los próximos 30 días sientes que este libro no habló el
              idioma que estabas buscando, escríbenos una línea. Te devolvemos
              cada centavo. Sin formularios. Sin justificaciones.
            </p>
            {variant === 'full' && <p className="text-sm md:text-base font-serif italic text-amber-200/80 leading-relaxed" data-id="element-107">
                El riesgo es nuestro. La transformación, tuya.
              </p>}
          </div>
        </div>
      </div>
    </motion.section>;
};